<template>
  <div class="flex-grow-1 d-flex flex-column p-3">
    <div class="flex-grow-1">
      <b-form-group label-cols-md="4" label-cols-lg="3">
        <template #label>
          <span class="text-gray-700 font-weight-bold">Nombre:</span>
        </template>
        <b-form-input 
          class="border-gray"
          :value="itemEditing.name" 
          @input="updateItem(['name', $event])" />
      </b-form-group>
  
      <b-form-group label-cols-md="4" label-cols-lg="3">
        <template #label>
          <span class="text-gray-700 font-weight-bold">Periodo de nómina:</span>
        </template>
        <!-- <b-form-select
          class="border-gray" 
          :options="payrollTypes" 
          :value="itemEditing.payroll_period" 
          @input="updateItem(['payroll_period', $event])"
        ></b-form-select>  -->
        
        <b-form-radio-group
          :options="payrollTypes" 
          :value="itemEditing.payroll_period" 
          @input="updateItem(['payroll_period', $event])"
          buttons
          button-variant="outline-ow-primary-500"
        ></b-form-radio-group>
      </b-form-group>
  
      <b-form-group label-cols-md="4" label-cols-lg="3">
        <template #label>
          <span class="text-gray-700 font-weight-bold">Categorias de nómina</span>
        </template>
        <b-form-checkbox-group
          :options="payrollCategories"
          :checked="itemEditing.payroll_categories"
          @input="updateItem(['payroll_categories', $event])"
          value-field="value"
          text-field="text"
          stacked
        >
        </b-form-checkbox-group>
      </b-form-group>
    </div>

    <div class="d-flex justify-content-end">
      <b-button variant="ow-primary-600" 
        class="mr-2" 
        @click="save"
        :disabled="isSaving"
      >
        <b-icon icon="arrow-clockwise" animation="spin" v-if="isSaving"></b-icon> Guardar
      </b-button>
      <b-button variant="secondary"
        @click="cancel"
        :disabled="isSaving"
      >
        Cancelar
      </b-button>
    </div>
  </div>
</template>

<script>
import { 
  mapOrganizationChartState,
	mapOrganizationChartGetters, 
	mapOrganizationChartMutations, 
	mapOrganizationChartActions 
} from "../../store/modules/organization-chart";

import {
  mapPayrollTypesState,
  mapPayrollTypesGetters
} from "../../store/modules/payroll-types";

import {
  mapPayrollCategoriesState,
  mapPayrollCategoriesGetters
} from "../../store/modules/payroll-categories";

import alertMixin from '../../mixins/alertMixin';

export default {
  mixins: [alertMixin],
  computed: {
    ...mapOrganizationChartState({
			isSaving: state => state.isSaving,
      itemEditing: state => state.itemEditing,
      savingFailureMessage: state => state.savingFailureMessage,
      savingFailureErrors: state => state.savingFailureErrors,
    }),
    ...mapPayrollTypesState({
      isPayrollTypesLoading: state => state.isLoading
    }),
    ...mapPayrollTypesGetters({
      payrollTypes: 'options'
    }),
    ...mapPayrollCategoriesState({
      isPayrollCategoriesLoading: state => state.isLoading,
    }),
    ...mapPayrollCategoriesGetters({
      payrollCategories: 'options'
    }),
  },
  methods: {
    ...mapOrganizationChartMutations([
      'cancel',
      'updateItem'
    ]),
    save() {
      this.$store
        .dispatch('organizationChart/save')
        .then(() => {
          this.viewSuccess();
        })
        .catch (error => {
          this.viewErrors(this.savingFailureMessage, this.savingFailureErrors);
          throw error;
        });
    }
  }
}
</script>
